import React, { useMemo, useCallback } from 'react'
import MaterialReactTable from 'material-react-table';
import {
    Typography,
    Box,
    Button,
    IconButton,
    Tooltip,
    MenuItem
} from '@mui/material';
//Import Material React Table Translations
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { grey } from '@mui/material/colors';
import { darken, useTheme, createTheme, ThemeProvider } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Delete, Edit } from '@mui/icons-material';
import ModalGestionAbierta from '../modales/ModalGestionAbierta';

const TablaGestionResuelta = ({ columnas, lineas, handleOpenNuevo, handleOpen, handleOpenAdjuntos, acciones, agregar, titulo }) => {
    const columns = useMemo(() => columnas, [])
    const [data, setData] = React.useState(lineas)
    const [pagination, setPagination] = React.useState({
        pageIndex: 0,
        pageSize: 10
    });


    React.useEffect(() => {
        if (lineas.length > 0) {
            setData(lineas)
        }
    }, [lineas])

    const openModalNew = () => {
        handleOpenNuevo()
    }

    //abrir modal
    const openModal = (row) => {
        let id = row.original.id
        handleOpen(id, row.original)
    }

    const openModalAdjuntos = (row) => {
        let id = row.original.id
        handleOpenAdjuntos(id, row.original)
    }

    return (
        <>
            <MaterialReactTable
                muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10],
                }}
                columns={columns}
                data={data}
                muiTablePaperProps={{
                    sx: (theme) => ({
                        borderRadius: '0.55rem',
                        border: darken(theme.palette.background.default, 0.1),
                        bgcolor: darken(theme.palette.background.default, 0.1),
                        // maxWidth: '1000px',
                        m: 'auto',
                    }),
                }}
                onPaginationChange={setPagination}
                state={{ pagination }}
                enableColumnFilterModes={true}
                enableColumnOrdering={true}
                enableColumnFilters={true}
                enableSorting={true}
                enableColumnResizing
                columnResizeMode="onChange"
                enablePinning
                enableRowActions={acciones}
                enableStickyHeader
                initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: 'compact', }}
                positionToolbarAlertBanner="bottom"
                localization={MRT_Localization_ES}
                defaultColumn={{
                    maxSize: 400,
                    minSize: 40,
                }}
                renderRowActionMenuItems={
                    ({ row }) => [
                        <>
                            {
                                agregar ? null : (

                                    <MenuItem key="resolucion" onClick={() => openModal(row)}>
                                        Ver gestión
                                    </MenuItem>
                                )
                            }
                            <MenuItem key="adjuntos" onClick={() => openModalAdjuntos(row)}>
                                Ver adjuntos
                            </MenuItem>
                        </>
                    ]
                }
                renderTopToolbarCustomActions={() => (
                    <>
                        {agregar ? (
                            <Button color="secondary" onClick={() => openModalNew()} variant="contained">
                                <PlaylistAddIcon />
                            </Button>
                        ) : null}
                        <Typography variant="subtitle" p="2px">
                            {titulo}
                        </Typography>
                    </>
                )}
            />

        </>
    )
}

export default TablaGestionResuelta